module.exports = __webpack_public_path__ + "static/media/clean2.e1615bee.jpg";